<template>
<div>

  <!--Primer cuadro a mostrar-->
  <div v-if="$route.params.page==null"> 
    <v-carousel 
    cycle class="altura" hide-delimiters
    :show-arrows="false">
      <v-carousel-item 
      v-for="lienzo in cuadros[0].galeria[0].imagenes" :key="lienzo">  
        <v-parallax :src="lienzo">
          <h1 class="titulo d-flex justify-center text-center">
            {{cuadros[0].titulo}} 
          </h1> 
        </v-parallax>
      </v-carousel-item>
    </v-carousel>

    <v-container class="mb-10 mt-0">
      <v-row 
      class="d-flex justify-center">
        <v-col   
        v-for="lienzo in cuadros[0].galeria[0].imagenes" 
        :key="lienzo.col"
        color="black" cols="4" md="3"
        class="d-flex child-flex pt-0">  
          <router-link class="black d-flex align-center lupa"
          :to="{name:'arte/:page', params:{page:cuadros[0].id,fotografia:lienzo}}">
            <v-img :src="lienzo" :alt="lienzo"
            spect-ratio="2" class="black" contain>
              <template v-slot:placeholder>
                <comcargando circulo="color2"></comcargando>
              </template>
                <h3 class="ampliar">Ampliar</h3>
            </v-img>
          </router-link> 
        </v-col>
      </v-row>
    </v-container>  
  </div>
  <!--primer cuadro-->

  <!--cuadros a mostrar segun eleccion-->
  <div  v-for="(item,index) in cuadros" :key="index"> 
    <div v-if="$route.params.page==item.id"> 

      <v-carousel v-for="img in item.galeria" :key="img.id"
      cycle class="altura" hide-delimiters
      :show-arrows="false">
        <v-carousel-item v-for="lienzo in img.imagenes" :key="lienzo.id">  
          <v-parallax :src="lienzo">
            <h1 class="titulo d-flex justify-center text-center">
              {{item.titulo}} 
            </h1> 
          </v-parallax>
        </v-carousel-item>
      </v-carousel>

      <v-container class="mb-10 mt-0">
        <v-row v-for="img in item.galeria" :key="img.id" 
        class="d-flex justify-center">

          <v-col   
          v-for="(lienzo, i) in img.imagenes" :key="i" 
          color="black" cols="4" md="3"
          class="d-flex child-flex pt-0">
              
            <router-link class="black d-flex align-center lupa"
            :to="{name:'arte/:page', params:{page:item.id ,fotografia:lienzo}}">
              <v-img :alt="lienzo"
              :src="lienzo" spect-ratio="2" 
              class="black" contain>
                <template v-slot:placeholder>
                  <comcargando circulo="color2"></comcargando>
                </template>
                 <h3 class="ampliar">Ampliar</h3>
              </v-img>
            </router-link>
          </v-col>
        </v-row>
      </v-container> 
    </div>
  </div> 

</div>
</template>

<style scoped>
.lupa{
  text-decoration: none;
  cursor: url('data:image/x-icon;base64,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'),zoom-in
}

@media (min-width:0px) and (max-width: 600px) {
  .altura{
    height:100px !important;
  }
   .titulo{
    font-size: 10vw !important;
  }
}
@media (min-width: 600px) and (max-width: 1200px) {
  .altura{
    height:200px !important;
  }
  .titulo{
    font-size:76px !important;
  }
}
@media (min-width:1200px) {
  .altura{
    height:300px !important;
  }
}
.titulo{
  font-family: 'Original Surfer', cursive;
  position: relative;
  bottom: 191px;
  font-size:138px;
   color: black;
  -webkit-text-fill-color: rgba(255, 255, 255, 0.438); 
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}
.ampliar{
   opacity: 0;
  }
/*para pantallas tactiles (sin hover) */
@media (pointer: coarse) {
  .ampliar{
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    -webkit-text-fill-color: rgba(255, 255, 255, 0.438);
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
  }
}
</style>

<script>
import comcargando from "@/components/ComCargando.vue"
export default {
  name: 'comCuadro',
   components:{
       comcargando,
    },
  props:['cuadros'],
    data:()=>({
    
    }),//data
 }//export default
</script>